import { useState, useEffect } from "react";

const navItems = [
  { label: "Processing Options", href: "#processing-options" },
  { label: "Services", href: "#services" },
  { label: "Service Area", href: "#service-area" },
  { label: "Travel Patterns", href: "#travel-timing" },
  { label: "Destinations", href: "#destinations" },
  { label: "Reviews", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Local Resources", href: "#local-resources" },
];

export default function ParklandStickyNav() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-14">
          <a
            href="https://fastpassportcenter.com"
            className="font-serif text-[#1A365D] font-bold text-lg"
          >
            Fast Passport Center
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-gray-600 hover:text-[#1A365D] text-xs font-medium px-2.5 py-1.5 rounded-md transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <a
              href="tel:8772530084"
              className="text-[#1A365D] text-xs font-semibold hover:text-[#F6C344] transition-colors whitespace-nowrap"
            >
              877-253-0084
            </a>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] text-xs font-bold px-4 py-2 rounded-md transition-all whitespace-nowrap"
            >
              Start Order
            </a>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-[#1A365D]"
          >
            <i className={`${isMobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setIsMobileOpen(false)}
                className="text-gray-600 hover:text-[#1A365D] text-sm font-medium py-2 px-3 rounded-md hover:bg-gray-50 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div>
          <div className="mt-3 pt-3 border-t border-gray-100 flex items-center gap-3">
            <a
              href="tel:8772530084"
              className="text-[#1A365D] text-sm font-semibold"
            >
              877-253-0084
            </a>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="bg-[#F6C344] text-[#1A365D] text-sm font-bold px-4 py-2 rounded-md whitespace-nowrap"
            >
              Start Order
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}